var dict = require("./dict");

module.exports = Object.keys(dict);



/*****************
 ** WEBPACK FOOTER
 ** ./~/anglicize/lib/characters.js
 ** module id = 572
 ** module chunks = 0
 **/